import { isArray } from "util"
import log from "./log"

const debug = true
let apiBaseURL = `http://localhost:5001/holstee-dev/us-central1/api/graphql`
if (typeof window !== "undefined") {
  apiBaseURL =
    window.location && window.location.hostname.includes("localhost")
      ? `http://localhost:5001/holstee-dev/us-central1/api/graphql`
      : `https://us-central1-holstee-dev.cloudfunctions.net/api/graphql`
}

export const handleApiError = (response, critical, tag) => {
  const isError = !!response && !!response.errors
  if (!isError && debug) {
    console.group(`API Success Response \`${tag}\``)
    if (response) console.log(response.data)
    console.groupEnd()
  }

  if (critical) {
    if (isError) {
      console.warn(`API Error: \`${tag}\``, response.errors)
      throw new Error(
        `API response \`${tag}\` generated critical error`,
        response.errors
      )
    }
  } else {
    if (isError) {
      console.warn(`API Error: \`${tag}\``, response.errors)
    }
  }

  return isError
}

export const apiRequest = async (path, query, accessToken) => {
  let rawResponse
  const body = {
    query,
  }
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  }
  if (accessToken) {
    headers["authorization"] = `Bearer ${accessToken}`
  }
  const apiUrl = `${apiBaseURL}/${path}`

  try {
    rawResponse = await fetch(apiUrl, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    })
    return await rawResponse.json()
  } catch (e) {
    console.log("## ", "Component Mount Error", e.message)
  }
}

export const testAPI = async token => {
  const query = `{hello}`
  const response = await apiRequest("client", query, token)
  handleApiError(response, false, "testAPI")
}

export const cacheRequest = client => {
  const cache = !!client.cache ? client.cache : client
  return {
    read: (key, query) => {
      try {
        let results = client.readQuery({ query })
        if (results && results[key]) {
          return results[key]
        }
        return null
      } catch (e) {
        console.warn("cacheRequest (Read) Failed on client:", client)
        return null
      }
    },
    updateDeleted: (data, target, query) => {
      let cached,
        updated = {}
      try {
        // Query cache for data
        cached = cache.readQuery({ query })

        // Add newest document to the beginning of array
        if (
          cached &&
          typeof cached === "object" &&
          cached[target] &&
          isArray(cached[target])
        ) {
          updated[target] = cached[target].filter(x => x.key !== data.key)
          log(
            "log"[
              ("cacheRequest.updateDeleted() updated existing cache",
              { cached, data, target, query, updated })
            ]
          )
        } else {
          updated[target] = []
          log(
            "log"[
              ("cacheRequest.updateDeleted() updated empty cache",
              { cached, data, target, query, updated })
            ]
          )
        }
        // Write new data to cache
        cache.writeQuery({
          query,
          data: updated,
        })
      } catch (error) {
        log("warn"[("cacheRequest.updateDeleted() FAILED", { error })])
      }
    },
    updateCreated: (data, key, query) => {
      let cached,
        updated = {}

      try {
        // Query cache for data
        cached = cache.readQuery({ query })

        // Add newest document to the beginning of array
        if (
          cached &&
          typeof cached === "object" &&
          cached[key] &&
          isArray(cached[key])
        ) {
          cached[key].unshift(data.document)
          updated[key] = cached[key]
          log(
            "log"[
              ("cacheRequest.updateCreated() updated existing cache",
              { cached, cache, client, data, key, query, updated })
            ]
          )
        } else {
          updated[key] = [data.document]
          log(
            "log"[
              ("cacheRequest.updateCreated() updated empty cache",
              { cached, cache, client, data, key, query, updated })
            ]
          )
        }
        // Write new data to cache
        cache.writeQuery({
          query,
          data: updated,
        })
      } catch (error) {
        log("warn"[("cacheRequest.updateCreated() FAILED", { error })])
      }
    },
    updateEdited: (data, key, query, index) => {
      let cached,
        updated = {}

      try {
        // Query cache for data
        cached = cache.readQuery({ query })

        // Add newest document to the beginning of array
        if (
          cached &&
          typeof cached === "object" &&
          cached[key] &&
          isArray(cached[key])
        ) {
          cached[key][index] = data.document
          updated[key] = cached[key]
          log(
            "log"[
              ("cacheRequest.updateEdited() updated existing cache",
              { cached, cache, client, data, key, query, index, updated })
            ]
          )
        } else {
          updated[key] = [data.document]
          log(
            "log"[
              ("cacheRequest.updateEdited() updated empty cache",
              { cached, cache, client, data, key, query, index, updated })
            ]
          )
        }
        // Write new data to cache
        cache.writeQuery({
          query,
          data: updated,
        })
      } catch (error) {
        log("warn"[("cacheRequest.updateEdited() FAILED", { error })])
      }
    },
  }
}

export const store = (cache, client, data, action, key, query) => {
  if (!cache) {
    new Error(
      `store() has an invalid cache parameter.  Please check your code.`
    )
  }
  console.log(`Store params for key ${key}`, {
    cache,
    client,
    action,
    data,
    key,
    query,
  })

  try {
    let readQuery = cache.readQuery({ query })
    console.log("Pre-write: readQuery data", {
      readQuery,
      rqKey: readQuery[key],
      dataAction: data[action],
    })
    cache.writeQuery({
      query,
      data: { userEntries: [data.document].concat(readQuery[key]) },
    })
    readQuery = cache.readQuery({ query })
    console.log("Post-write: readQuery data", readQuery)
  } catch (e) {
    console.warn(`cache.readQuery failed`, e)
    client
      .query({
        query,
      })
      .then(result => {
        console.log(`Cache key ${key} is undefined.  Querying for new data...`)
        console.log(result)
      })
  }
  if (query[key]) {
    console.log(`Found cache for key ${key}`, { queryData: query[key] })
  }
}
